function isJson(value: any) {
	try {
		JSON.parse(value);
	} catch (e) {
		return false;
	}
	return true;
}

export const setToken = (token: string) => {
	localStorage.setItem('token', token);
};

export const clearToken = () => {
	localStorage.removeItem('token');
};

export const getToken = () => {
	return localStorage.getItem('token');
};

export const setLocalStorage = (key: string, value: any): void => {
	localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key: string): any => {
	const value = localStorage.getItem(key);
	if (value && isJson(value)) {
		return JSON.parse(value);
	}
	return localStorage.getItem(key);
};

export const clearLocalStorage = (key: string) => {
	localStorage.removeItem(key);
};

export const clearAllLocalStorage = () => {
	localStorage.clear();
};
